/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function(){
  $(".quantity-selector__value").change(function() {  
    var qty = $(this).find(':selected').data('picone');
    var id = $(this).find(':selected').data('pictwo');
     window.location.href = "/cart/change?quantity="+qty+"&id="+id;
//     if(qty == "1"){
//       window.location.href = "/cart/change?quantity=1&id="+id;
//     }
//     if(qty == "255"){
//       window.location.href = "/cart/change?quantity=255&id="+id;
//     }
//     if(qty == "510"){
//       window.location.href = "/cart/change?quantity=510&id="+id;
//     }
//     if(qty == "765"){
//       window.location.href = "/cart/change?quantity=765&id="+id;
//     }
//     if(qty == "1020"){
//       window.location.href = "/cart/change?quantity=1020&id="+id;
//     }
    
//     $.ajax({
//      url: "/cart/change?quantity=1&id=36543535546520:f001331ce9d9022dcfc4350f79878acd",
//      success: function(msg){
//        alert("success");
//      }
//    });
  });
});